import { render, staticRenderFns } from "./fsNotify.vue?vue&type=template&id=82937660"
import script from "./fsNotify.vue?vue&type=script&lang=js"
export * from "./fsNotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports